import React, { useState } from 'react';
import  { Marker } from 'react-mapbox-gl';
import locationPin from '../../Assets/images/paint-roller.png'
import 'mapbox-gl/dist/mapbox-gl.css';
import MapMarker from '../../Components/MapMarker';
import './styles.scss';

// import mapboxgl from 'mapbox-gl';
// // eslint-disable-next-line import/no-webpack-loader-syntax
// mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

// const Map = ReactMapboxGl({
//     accessToken: "pk.eyJ1Ijoic3BlbnNlcmxlaWdodG9uMSIsImEiOiJjbDB3Nm9hbjYxZHNvM2NwbmsydnE3NnpnIn0.r7KsR8MDpuPnql6SP5YSAw"
// });

const MapContainer = ({ Map, mapPins }) => {
    const [popup, setPopup] = useState(null);

    const handleClick = (popup) => {
        setPopup(popup)
    }

    let mapPinsDisplay = mapPins.length ? mapPins.map((pin,i) => {
        return (
            <Marker
                coordinates={[pin.long, pin.lat]}
                anchor="bottom"
                key={i}
                onClick={() => handleClick(i)}
                >
                    <div className="marker" data-popup={i}>
                        <span className='outer'>{pin.title}</span>
                        <img src={locationPin} alt="f" />
                    </div>
            </Marker>
        )
    }) : '';

    let mapPopUpsDisplay = mapPins.length ? mapPins.map((pin,i) => {
        return (
            <MapMarker popup={popup} index={i} key={i} handleClick={handleClick} {...pin}/>
        )
    }) : '';
    
    return (
        <div className="map-container">
            {mapPopUpsDisplay&&mapPopUpsDisplay}
            <Map
            style="mapbox://styles/mapbox/streets-v9"
            center={["-104.9913247","39.6793360"]}
            containerStyle={{
                height: 'calc(100vh - 76px)',
                width: '100vw'
            }}
            >
                {mapPinsDisplay&&mapPinsDisplay}
            </Map>
        </div>
    );
}

export default MapContainer;
